import React from 'react';
import Banner from '../components/homecomponents/Banner';
import LatestArticles from '../components/homecomponents/LatestArticles';
import Contact from '../components/homecomponents/Contact';
import Lessons from '../components/homecomponents/Lessons';
import Publications from '../components/homecomponents/Publications';
import Team from '../components/homecomponents/Team';
/*
import {
  useGetPublicationsQuery,
  useGetLessonsQuery,
  useGetArticlesQuery,
} from '../../redux/public/publicSlice';
*/
import {
  useGetPublicationsQuery,
  useGetLessonsQuery,
  useGetArticlesQuery,
} from '../../redux/apiSlice';

function Home() {
  const {
    data: publications,
    error: pubsError,
    isLoading: pubsLoadingStatus,
    isSuccess: pubsSuccessStatus,
    isError: pubsErrorStatus,
  } = useGetPublicationsQuery();

  const {
    data: lessons,
    error: lessonsError,
    isLoading: lessonsLoadingStatus,
    isSuccess: lessonsSuccessStatus,
    isError: lessonsErrorStatus,
  } = useGetLessonsQuery();

  const {
    data: articles,
    error: articlesError,
    isLoading: articlesLoadingStatus,
    isSuccess: articlesSuccessStatus,
    isError: articlesErrorStatus,
  } = useGetArticlesQuery();

  const loadingStatus = pubsLoadingStatus || lessonsLoadingStatus || articlesLoadingStatus;

  return (
    <>
      <Banner loading={loadingStatus} />
      <LatestArticles
        articles={articles}
        errorStatus={articlesErrorStatus}
        sucessStatus={articlesSuccessStatus}
        error={articlesError}
      />
      <Contact />
      <Publications
        pubs={publications}
        errorStatus={pubsErrorStatus}
        sucessStatus={pubsSuccessStatus}
        error={pubsError}
      />
      <Team />
      <Lessons
        lessons={lessons}
        errorStatus={lessonsErrorStatus}
        sucessStatus={lessonsSuccessStatus}
        error={lessonsError}
      />
    </>
  );
}

export default Home;
